import React, { useLayoutEffect, useEffect, useState, useRef, useContext} from "react";
import store from "@/redux/store";
import {checkItem, createDossierItem} from '@/reducers/CommunicationCycle';
import moment from 'moment';
import CalenderHelperClass from '@/helpers/CalenderHelper'
//import {timeCheckMe} from '@/helpers/CalenderHelper'
import EventItem from './EventItem'
import { ReactReduxContext } from 'react-redux'

interface IEventProps {
    viewType?: string,
    day: any,
    items: any,
    className?:string,
    dragOverClass?:string,
    draggable?: boolean,
    canDrop?: boolean,
    boe?: string,
    onClickEventHandler?: Function,
    onClickDayHandler?: Function,
    dragOverElement?: React.DragEventHandler<HTMLDivElement>,    
    onDragOver?: React.DragEventHandler<HTMLDivElement>,
    onDragEnter?: React.DragEventHandler<HTMLDivElement>,
    onDragLeave?: React.DragEventHandler<HTMLDivElement>,
    onMouseEnter?: Function,
    onMouseLeave?: Function,
    saveItemHandler?: Function,
    onEventItemClickEvent?: Function,
    cloneElement?: null
}

class CalenderItem extends React.Component<IEventProps, any> {
    cloneElement = null;
    
    constructor(props:IEventProps) {
        super(props);
        this.onDragOverHandler = this.onDragOverHandler.bind(this);
        this.onDragLeaveHandler = this.onDragLeaveHandler.bind(this);
        this.onDrop = this.onDrop.bind(this);
        
        
    let defaultProps: IEventProps = {
 className: '',
 dragOverClass: '',
 day: null,
 items: [],
 saveItemHandler: () => null,
 cloneElement: null,
 onClickEventHandler: () => null,
 onClickDayHandler: () => null,
//    onDragOver: this.onDragOver,
//    onDragLeave: this.onDragLeave,
//    onDragEnter: null,
 };
 
    if(props.viewType == "schedule") {
        //this.onDayClickEventHandler = this.onDayClickEventHandler.bind(this);
        //defaultProps.onClickEventHandler = this.onDayClickEventHandler;
    }
        let propsForState = {...props};
        if(!propsForState?.onClickDayHandler) {
            delete propsForState?.onClickDayHandler;
        }
        this.state = {dragOverElementId: null,props: {...defaultProps, ...propsForState}};
        this.cloneElement = null;
        //this.activelement = null;
        
        
        
    }

    onDayClickEventHandler(event) {
        event.preventDefault();
        return false;
    }

    onDragLeaveHandler(event) {
        event.preventDefault();
//        console.clear();
        
        let {dragOverElementId} = this.state;
        const dragOverElement2 = document.getElementById(dragOverElementId);        
        if(dragOverElement2) {
            dragOverElement2.style.background = null;
            //dragOverElement2.removeAttribute(CalenderHelperClass.onDragHoverClassName);
        }
        if(this.cloneElement && event.target.id == this.cloneElement.id) {
            this.cloneElement.removeEventListener("dragleave", this.onDragLeaveHandler );
            this.cloneElement.removeEventListener("drop", this.onDrop );
             this.cloneElement.remove();
             this.cloneElement = null;
        }
        
    }  
    
    onDrop(event) {
        const {day} = this.state.props;
        let dragItem = store.getState().CommunicationCycleReducer.dragItem;
        if(!dragItem || dragItem.item.changedDayKey) return;
        // Check on update!!!!!
        store.dispatch( createDossierItem({day:day, dossier:dragItem}) );

        if(this.cloneElement ) {
            this.cloneElement.removeEventListener("dragleave", this.onDragLeaveHandler );
            this.cloneElement.removeEventListener("drop", this.onDrop );
             this.cloneElement.remove();
             this.cloneElement = null;
        }
            store.dispatch( checkItem(null) );
            event.preventDefault();
            return false;    
        
    }
      
    onDragEnterHandler(event) {
//        event.preventDefault();
//        return false;

        const {day} = this.state.props;
        let dragItem = store.getState().CommunicationCycleReducer.dragItem;
        
        
        let dayEl = document.getElementById(day['key'])
        if(!dragItem.item.dayKey && dragItem.item.dayKey == dayEl.id) {
            store.dispatch( checkItem(null) );
            event.preventDefault();
            return false;    
        }
//        this.cloneElement = dayEl.cloneNode(true);
        
        //CalenderHelperClass.getParentElement(event.target, "itemsPanel");
            let root = document.getElementById("days");
            let clone = document.getElementById("clone");
            if(clone) {
                //clone.remove();
            }
            let withCheck = true;
        if(!this.cloneElement) {
        this.cloneElement = CalenderHelperClass.setCloneElement( dayEl )
        
        this.cloneElement.addEventListener("dragleave", this.onDragLeaveHandler );
        this.cloneElement.addEventListener("drop", this.onDrop );
        //this.cloneElement.style.zoom = 1;
        /*
        this.cloneElement.style.position = 'absolute';
        this.cloneElement.style.border = '1px solid #d2d2d2';
        console.info("bound" , root.getBoundingClientRect());
        let rec = dayEl.getBoundingClientRect();
        let rootrec = root.getBoundingClientRect();
        console.info("bound", rec );
        let zoomFactor = 1.2
        this.cloneElement.style.width = rec.width+"px";
        this.cloneElement.style.left = (((rec.left - rootrec.left)/zoomFactor) - (rec.width/6))+"px";;
        this.cloneElement.style.top = (((rec.top - rootrec.top)/zoomFactor)- (rec.height/6))+"px";;
        this.cloneElement.style.minHeight = rec.height + (rec.height/6)+"px";
        this.cloneElement.style.width = rec.width + (rec.width/6)+"px";
        this.cloneElement.style.zindex = 9999;
        this.cloneElement.style.zoom = zoomFactor;
        this.cloneElement.style.height = (rec.height*2)+"px";
        
//        this.cloneElement.style.top = event.pageY+"px";;
        this.cloneElement.id = "clone";
        */
        //this.cloneElement.replaceChild
       
        } else {
            withCheck = false;
            CalenderHelperClass.addCloneToView(this.cloneElement)
            
        }
        let itemsPanel = this.cloneElement.childNodes.item(1);
        
        let ret = store.dispatch( checkItem({day:day, eventElement:itemsPanel, withCheck:withCheck}) );
        
        
        
    }
    
    onDragOverHandler(event) {
            event.preventDefault();
//        let root = document.getElementById("days");
//        let dragItem22 = store.getState().CommunicationCycleReducer.dragItem;
//        dragItem22.element.background = 'red';
//        dragItem22.element.style.left = (event.pageX - root.getBoundingClientRect().left)+"px";
//        dragItem22.element.style.top = (event.pageY  - root.getBoundingClientRect().top)+"px";
//        
//        console.debug( event.pageX , root.getBoundingClientRect());
        //
        let {dragOverElementId} = this.state;
        let {canDrop, day} = this.state.props;
        
        let dragItem = store.getState().CommunicationCycleReducer.dragItem;
            //event.preventDefault();
        let dayEl = document.getElementById(day['key'])
        if(dragItem.item.dayKey == dayEl.id) {
            return false;    
        } else {
            
        }
        
        if(dragOverElementId && dragOverElementId != event.target.dataset.key) {
        //if(dragOverElementId) {
        let dragOverElement2 = document.getElementById(dragOverElementId);
            dragOverElement2.style.background = null;
        }
        
        
        
        //event.target.setAttribute(CalenderHelperClass.onDragHoverClassName, "1");
        if(event.target && event.target.dataset.candrop == "1") {
            //event.target.style.background = "#e8f1fd";
        } else if(event.target && event.target.dataset.candrop == "0") {
            //event.target.style.background = "red";
        }
            //let newStateObj = {...this.props};

        //const {day} = this.props;
            let parent = event.target.parentElement;
            //parent.dataset.selectedkey = event.target.id;
        if(dragOverElementId != event.target.dataset.key) {
            this.setState({dragOverElementId: event.target.dataset.key});
        
        }
        
//          const data = event.dataTransfer.getData("text");
 //         
//    const source = document.getElementById(data);
//        if(source) {
//            source.style.left = (event.target['offsetLeft']+30)+"px";
//            source.style.top = (event.target['offsetTop']+5)+"px";
//            source.style.width = event.target['width']+"px";
//            source.style.height = "20px";
//            source.style.background = "blue";
//        }   
                 
    }
    
    onSaveEvent=((item) => {
        const {day, saveItemHandler} = this.state.props;
        saveItemHandler(item, day.index);
    })
    
    
    render() {
        let {day, className, onDragOver, onDragEnter, onDragLeave, canDrop, items, saveItemHandler, onEventItemClickEvent, onClickEventHandler, onClickDayHandler} = this.state.props;
        let isEventDraggable = false;
        if(this.props?.viewType != "schedule") {
            isEventDraggable = true;
        } else {
            onEventItemClickEvent = () => null;
        }
        
        
        let currentDate = moment().format("YYYYMMDD");
        let newclassName = className;
        if(parseInt(currentDate) > day.daykey) { 
            newclassName = className + " history "; 
        }
        
        let totalEvents = 0;
        if(Array.isArray(items)) {
            totalEvents = items.length; 
        }
        
        return (
            <div 
                id={day.key}
                data-key={day.key}
                data-daykey={day.daykey}
                data-index={day.index}
                data-month={day.month}
                data-year={day.year}
                data-day={day.day}
                key={day.date}
                className={newclassName + " calenderItem "+ ((canDrop)? "calender_accept" : "calender_disable")}
                onClick={(event) => {onClickDayHandler(event, day)}}
                onDragOver={(event) => {this.onDragOverHandler(event)}}
                onDragEnter={(event) => {this.onDragEnterHandler(event)}}
                onDragLeave={(event) => {this.onDragLeaveHandler(event)}}
                data-candrop={(canDrop)? 1 : 0}
                data-history={(parseInt(currentDate) > day.daykey) ? "1" : "0"}
                
            >
                <time
                  dateTime={day.date}
                  className={
                    day.isToday
                      ? 'flex size-6 items-center justify-center rounded-full bg-indigo-600 font-semibold text-white'
                      : undefined
                  }
                >
                  {day.date.split('-').pop().replace(/^0/, '')} 
                </time>
                <div id="itemsPanel" className="items" event-count={totalEvents}>
                    {items && items.map((item, index) => {
// 
                    return <EventItem key={item.key} item={item} onEventItemClickEvent={onEventItemClickEvent}
                        className="event"
                        draggable={isEventDraggable}
                        saveItemHandler={this.onSaveEvent}        
                        />
                        
                    })}
                </div>
            </div>
        )
        
    }
}

export default CalenderItem; 
